import { useState } from 'react';
import { Outlet } from 'react-router';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/componentes/ui/sheet';
import { Navegacao } from './Navegacao';
import { Topbar } from './Topbar';

/**
 * Casca do painel autenticado.
 *
 * Barra lateral fixa a partir de `md`; abaixo disso o **mesmo** menu vira uma gaveta aberta pelo
 * botão da Topbar — nada de menu espremido em coluna estreita, e nada de uma segunda lista de itens
 * para manter em sincronia.
 */
export function Shell() {
  const [menuAberto, setMenuAberto] = useState(false);

  return (
    <div className="flex min-h-dvh flex-col bg-background text-foreground">
      <Topbar aoAbrirMenu={() => setMenuAberto(true)} />

      <div className="flex flex-1">
        <aside className="hidden w-64 shrink-0 border-r border-border bg-sidebar p-3 md:block">
          <Navegacao />
        </aside>

        <Sheet open={menuAberto} onOpenChange={setMenuAberto}>
          <SheetContent side="left" className="w-72 p-0">
            <SheetHeader>
              <SheetTitle>Menu</SheetTitle>
            </SheetHeader>
            <div className="px-3 pb-6">
              {/* Fechar a gaveta ao navegar: senão ela cobre a tela que a pessoa acabou de abrir. */}
              <Navegacao aoNavegar={() => setMenuAberto(false)} />
            </div>
          </SheetContent>
        </Sheet>

        <main className="min-w-0 flex-1 px-4 py-8 md:px-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
